module.exports = __webpack_public_path__ + "assets/images/project/japan.jpg?v=0ef896ad";